module.exports = __webpack_public_path__ + "img/mz_01.41459acf.png";